import styled from 'styled-components';
import { tokens } from '../../../../public/tokens';
import { CHART_TEXT_COLOR } from '../../../library/Chart';

/** Starts pies at 12 o'clock and runs them clockwise. */
export const PIE_ANGLES = { startAngle: 90, endAngle: -270 };

export const LegendText = styled.span({
    color: CHART_TEXT_COLOR,
    fontSize: tokens.typography.fontSize['md-12px'],
});
